export default __webpack_public_path__ + "static/media/ace_of_pentacles.b3ad0a05.png";